class HistoryDataProcessor{
    process(historyData, thresholds){


        for (let i = 0; i< historyData.length; i++){
            try{
                const currentThreholds = historyData[i].thresholds || thresholds
                if( ! historyData[i].minSecurityScore){
                    historyData[i].minSecurityScore = currentThreholds.minSecurityScore
                }
                if( ! historyData[i].minStabilityScore){
                    historyData[i].minStabilityScore = currentThreholds.minStabilityScore
                }
                if( ! historyData[i].minLicensingScore){
                    historyData[i].minLicensingScore = currentThreholds.minLicensingScore
                }
            }
            catch(e){
                continue
            }
        }


        return historyData

    }
}

export default HistoryDataProcessor